const handleSurvey = (partnerId, page) => {
  if (partnerId) {
    const SURVEY_SRC = process.env.REACT_APP_SURVEY_SRC;
    const SURVEY_TOKEN = process.env.REACT_APP_SURVEYSENSUM_TOKEN;
    const script = document.createElement('script');
    script.setAttribute('data-survey-token', SURVEY_TOKEN);
    script.src = SURVEY_SRC;
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      setTimeout(() => {
        if (process.env.REACT_APP_ENV === 'production') {
          const jstriggerEnv = 'prod-partnerportal';
          window.surveysensum.setUserInfo({
            Name: partnerId,
            Email: `${partnerId}@easebuzz.in`,
            Page: page
          });
          window.surveysensum.startSurvey(jstriggerEnv, { vz7: page });
        }
      }, 2000);
    };
  }
};
export default handleSurvey;
